export default __webpack_public_path__ + "be6c838b95eab2ce35f9b6eab06a47a7.png";